// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useInterval } from '../../../lib/utility';
import { FormattedMessage, useIntl } from 'react-intl';

const S = {
  Container: styled.div`
    white-space: nowrap;
    width: 280px;
    border-bottom: 1px solid #A6A6A6;
    padding-bottom: 5px;
    padding-left: 32px;

    > * + * {
      margin-left: 14px;
    }
  `,
  WorkshopText: styled.span`
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #434343;
  `,
}

interface Props extends React.ComponentPropsWithRef<'div'> {
  endTime: Date;
}

const WorkshopLabel = (props: Props): JSX.Element => {
  const { endTime, ...otherProps } = props
  const intl = useIntl();
  const getCountdownString = useCallback((time: Date) => {
    const debug = false;
    const now = new Date();
    let diff = (time.getTime() - now.getTime()) / 1000;
    if (diff <= 0) {
      return '已結束';
    }
    const day = Math.floor(diff / 86400);
    diff -= day * 86400;
    const hour = Math.floor(diff / 3600);
    diff -= hour * 3600;
    const minute = Math.floor(diff / 60);
    diff -= minute * 60
    const second = Math.floor(diff);
    if (day) {
      return <FormattedMessage id="Z001" values={{ day, hour }} />
    } else if (hour) {
      return <FormattedMessage id="Z001-1" values={{ hour, minute }} />
    } else {
      return <FormattedMessage id="Z001-2" values={{ day, hour, minute, second }} />
    }
  }, [])
  const [countdownString, setCountdownString] = useState(getCountdownString(endTime));
  useInterval(() => {
    setCountdownString(getCountdownString(endTime))
  }, 1000)

  return (
    <S.Container {...otherProps}>
      <S.WorkshopText>{intl.formatMessage({ id: 'E029' })}</S.WorkshopText>
      <S.WorkshopText>{countdownString}</S.WorkshopText>
    </S.Container>
  );
}

export { WorkshopLabel as default };
